var ImportOrganizationsAndUsersModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import ResponseImportModelModal from 'trunks/vue/admin/compositions/response_import/response_import_model.js';

import ResponseImportModalMixin from 'trunks/vue/admin/compositions/response_import/response_import_modal_mixin.js';

import {
  newSpinner
} from 'trunks/vue/admin/components/spinner.js';

export default ImportOrganizationsAndUsersModal = Vue.extend({
  mixins: [ResponseImportModalMixin],
  components: {
    'modal': Modal,
    'import-model-modal': ResponseImportModelModal
  },
  data: function() {
    return {
      createNotExistOrg: false
    };
  },
  template: `<modal title="导入组织和成员关系"
       extendClass="responses-import-modal import-users-and-organizations-modal"
       ref="modal">
  <import-model-modal :uploadRequest='uploadRequest'
                      :requestError='requestError'
                      :requestSuccess='requestSuccess'
                      :file='file'
                      @closeUploadMask='closeUploadMaskFunc'
                      @removeFile='removeFileFunc'>

    <template slot="importRecords">
      <a href="/admin/import_records"
         class="btn-link gray-text ml-1 mr-1">导入记录-导入组织和成员关系</a>
    </template>

    <template slot="fileUpload">
      <input type="file"
             accept=".xlsx"
             hidden='true'
             @change='filesChangedFunc'
             ref="uploadInput"/>
    </template>
    
    <template slot="tips">
      <div class="option-container">
        <div class="options">
          <label class="option-item">
            <input hidden="true" v-model="createNotExistOrg" type="checkbox">
            <i class="slp-square-o"></i>
            <span class="option-label">是否创建不存在的组织</span>
          </label>
        </div>
      </div>
    </template>
    
    <template slot="downloadTemplate">
      <a href="/downloads/导入成员和组织关系模板.xlsx"
         class="gray-link" target="_blank"
         download="批量更新用户.xlsx">点击下载导入模板</a>
    </template>
  </import-model-modal>
  <div class="modal-footer" slot='footer'>
    <button :disabled="requestSuccess"
            class="outlined btn-default"
            @click='cancel'>取消</button>
    <button :disabled="buttonDisabled"
            @click='ensure("ImportRecord::OrganizationMembers")'>确定</button>
  </div>
</modal>`,
  methods: {
    ensure: function(type) {
      if (this.requestSuccess) {
        return location.reload();
      } else {
        return this.importFile(type);
      }
    },
    getData: function(id, type) {
      var data;
      return data = {
        type: type,
        attachment_id: id,
        create_not_exist_org: this.createNotExistOrg ? 1 : 0
      };
    },
    doRequest: function(id, type) {
      return Skylark.Libs.Ajax.post("/admin/import_records", {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: this.getData(id, type),
        success: () => {
          this.requestSuccess = true;
          return this.requestError = false;
        },
        error: function(xhr, status, error) {
          var text;
          text = error.error ? error.error : "导入失败";
          return Skylark.Bridge.newAlertify(text, {
            type: 'error'
          });
        }
      });
    }
  }
});
